import { PermissionsItem } from '@/modules/api/codegen';
import { AccessRole } from '@/types';

export const permissionByRole = {
    [AccessRole.EDITOR]: [PermissionsItem.write, PermissionsItem.read],
    [AccessRole.VIEWER]: [PermissionsItem.read],
    [AccessRole.VIEWER_AUTOFILL_ONLY]: [PermissionsItem.autofillOnly],
    [AccessRole.VIEWER_PASSKEY_ONLY]: [PermissionsItem.passkeyOnly],
};

export const permissionToRole = (accessPermission: PermissionsItem[]) => {
    if (accessPermission.includes(PermissionsItem.write)) {
        return AccessRole.EDITOR;
    }

    if (accessPermission.includes(PermissionsItem.autofillOnly)) {
        return AccessRole.VIEWER_AUTOFILL_ONLY;
    }

    if (accessPermission.includes(PermissionsItem.passkeyOnly)) {
        return AccessRole.VIEWER_PASSKEY_ONLY;
    }

    return AccessRole.VIEWER;
};

export const hasWritePermission = (permissions: PermissionsItem[] = []) => permissions?.includes(PermissionsItem.write);

export const hasReadPermission = (permissions: PermissionsItem[] = []) =>
    permissions?.includes(PermissionsItem.read) || permissions?.includes(PermissionsItem.write);
